<script>
import * as util from '../../utilities/utilities';
import animation from '../components/animate.vue';
import magnetic from '../components/Magnetic.vue';

export default {
    components: {
        animation,
        magnetic
    },

    data() {
        return {
            controller: new ScrollMagic.Controller(),
            scene: null,
            breakPoint: 1024
        };
    },

    computed: {
        pinTrack() {
            return this.$refs.scrollingArticles.clientHeight - this.$refs.pinnedArticle.clientHeight;
        }
    },

    mounted() {
        this.scrollSetup();
        window.addEventListener('resize', this.scrollSetup);
    },

    methods: {
        scrollSetup() {
            if (!this.scene && window.innerWidth >= this.breakPoint) {
                this.initScrolling();
            } else if (this.scene && window.innerWidth < this.breakPoint) {
                this.destroyScrolling();
            }
        },

        initScrolling() {
            this.scene = new ScrollMagic.Scene({
                triggerElement: this.$refs.scrollingArticles,
                offset: window.innerHeight / 2,
                duration: this.pinTrack
            })
                .setPin(this.$refs.pinnedArticle)
                .addTo(this.controller);
        },

        destroyScrolling() {
            this.scene.destroy(true);
            this.scene = null;
        }
    }
};
</script>
